import type { RootState } from "store";

export const selectIndicatorsInstances = (state: RootState) => state.indicators.instances;
export const selectIndicatorsCount = (state: RootState) => state.indicators.instances.length;
export const selectFavoriteIndicators = (state: RootState) => state.indicators.favorites;
